import * as React from "react";
import { ITransaction } from "@/types/transaction";
import { Stack } from "@mui/material";
import StatusBox from "../../status-box";
import FinancialSummaryTitle from "./title";
import { humanDate } from "@/utils";

interface IFinancialSummaryProps {
  item: any;
}

const FinancialSummary: React.FunctionComponent<IFinancialSummaryProps> = ({
  item,
}) => {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      spacing={0}
      width="100%"
      justifyContent={"space-between"}
    >
      {/* name of the transation */}
      <FinancialSummaryTitle title={item?.transactionable?.title} />
      {/* Amount of the transations */}
      <FinancialSummaryTitle
        title={(item?.quantity || 0)?.withCommas()?.withPriceUnit()}
      />
      <StatusBox status={item?.status} />
    </Stack>
  );
};

export default FinancialSummary;


